<template>
<div
    @click.stop="setContent"
    :class="{son: hasParent, borderSon: !isActive}"
>
    <div v-if="item.content" class="parent" :class="{borderSon: hasParent}">
        <collapse
            :ref="item.translation.name"
            :active-index="0"
            :lastContent="lastContent"
        >
            <collapse-item
                :title="item.translation.name"
                :name="item.translation.name"
                nopadding
                course
                :style="defineCollapseItemStyle()"
            >
                <template #title>
                    <div class="title-container" :class="changeClassType()">
                        <div v-if="item.type === 'Module'" style="padding-right: 10px;" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="30" viewBox="0 0 24 30">
                                <title>Book</title>
                                <g>
                                    <path d="M23,0H1A1,1,0,0,0,0,1V29a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V1A1,1,0,0,0,23,0ZM2,2H4V28H2ZM22,28H6V2H22Z" fill="navy"/>
                                    <path d="M9,13H19a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H9A1,1,0,0,0,8,6v6A1,1,0,0,0,9,13Zm1-6h8v4H10Z" fill="#22242b"/>
                                    <path d="M18,19H10a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z" fill="#22242b"/>
                                    <path d="M16,23H12a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z" fill="#22242b"/>
                                </g>
                            </svg>
                        </div>

                        <div v-if="item.type === 'Lesson'" style="padding-right: 10px;" >
                            <svg fill="#000000" height="30px" width="30px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 512 512" xml:space="preserve">
                                <g>
                                    <g>
                                        <path d="M486.4,51.2H268.8V12.8C268.8,5.726,263.074,0,256,0c-7.074,0-12.8,5.726-12.8,12.8v38.4H25.6C11.46,51.2,0,62.66,0,76.8
                                            v281.6C0,372.54,11.46,384,25.6,384h130.671l-40.303,110.822c-2.423,6.647,1.015,13.986,7.646,16.401
                                            c1.459,0.529,2.935,0.776,4.386,0.776c5.222,0,10.138-3.226,12.023-8.422L183.509,384H243.2v76.8c0,7.074,5.726,12.8,12.8,12.8
                                            c7.074,0,12.8-5.726,12.8-12.8V384h59.691l43.486,119.578C373.862,508.774,378.778,512,384,512c1.451,0,2.927-0.247,4.378-0.776
                                            c6.639-2.415,10.078-9.754,7.646-16.401L355.729,384H486.4c14.14,0,25.6-11.46,25.6-25.6V76.8C512,62.66,500.54,51.2,486.4,51.2z
                                            M486.4,358.4H25.6V76.8h460.8V358.4z"/>
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <path d="M384,307.2H128c-7.074,0-12.8,5.726-12.8,12.8c0,7.074,5.726,12.8,12.8,12.8h256c7.074,0,12.8-5.726,12.8-12.8
                                            C396.8,312.926,391.074,307.2,384,307.2z"/>
                                    </g>
                                </g>
                            </svg>
                        </div>

                        <slot name="title">
                            <span :title="item.translation.name" class="span-title">
                                {{ $trim(item.translation.name, 35) }}
                            </span>
                        </slot>
                        <div class="icons-container">
                            <i
                                v-if="item.hasCertificate && this.actualLesson.progress >= this.item.certificateProgress"
                                @click="goToCertificate"
                                class="mdi mdi-trophy"
                            />
                        </div>
                    </div>
                </template>
                <class-menu-content
                    class="class-menu-content"
                    v-for="(filho, i) in item.content"
                    :key="i"
                    :item="filho"
                    :childLevel="childLevel + 1"
                    :is-active="filho.active"
                    :parentId="item.id"
                    :parentType="item.type"
                    hasParent
                    :lastContent="lastContent"
                />
            </collapse-item>
        </collapse>
    </div>
    <div v-else>
        <div
            v-if="!item.final"
            :style="[isActive && $bgColor(color.primary)]"
            class="class-item mb-0 br-0"
        >
            <div class="col-12">
                <div
                    class="d-flex align-items-center"
                    :style="isActive && { color: color.secondary }"
                >
                    <i v-if="item.type === 'Exercise'" class="mdi mdi-pencil" style="padding-right: 20px; font-size: 25px;"/>
                    <i v-if="item.type === 'Video'" class="mdi mdi-play" style="padding-right: 20px; font-size: 25px;"/>

                    <div class="d-flex align-items-center">
                        <span v-if="item.lock"> <i class="mdi mdi-lock-outline mr-2"/> </span>
                        <span v-else-if="item.progress === 100"> <i class="mdi mdi-checkbox-marked mr-2"/> </span>
                        <span v-else> <i class="mdi mdi-checkbox-blank-outline mr-2"/> </span>
                        <slot name="title">
                            <h6
                                :title="item.translation.name"
                                class="side-bar-text font-weight-bold mb-0"
                                :style="isActive && { color: color.secondary }"
                            >
                                {{ $trim(item.translation.name, 35) }}
                            </h6>
                        </slot>
                    </div>
                    <!-- <i v-if="item.type === 'Exercise'" class="mdi mdi-notebook mdi-18px"/> -->
                </div>
                <div class="text-muted side-bar-text">
                    <span v-if="item.time_video">
                        {{$t('common.duration')}}: {{ item.time_video }}
                    </span>
                    <span v-if="isLive"><i class="mdi mdi-circle pl-2"></i>{{$t('content.type.live')}}</span>
                    <span v-if="item.type_upload">
                        <i class="mdi mdi-file pr-1"/>{{$t('content.type.file')}}
                    </span>
                </div>
            </div>
            <class-content-progress-bar v-if="isActive" :progress="this.content.progress"/>
        </div>
        <div
            v-if="item.final && showFinal"
            :style="[isActive && $bgColor(color.primary)]"
            class="class-item"
        >
            <div class="col-12">
                <div
                    class="d-flex align-items-center"
                    :style="isActive && { color: color.secondary }"
                >
                    <i v-if="item.type === 'Exercise'" class="mdi mdi-pencil" style="padding-right: 20px; font-size: 25px;" />
                    <i v-if="item.type === 'Video'" class="mdi mdi-play" style="padding-right: 20px; font-size: 25px;"/>

                    <div class="d-flex align-items-center">
                        <span v-if="item.progress === 100"> <i class="mdi mdi-checkbox-marked mr-2"/> </span>
                        <span v-else> <i class="mdi mdi-checkbox-blank-outline mr-2"/> </span>
                        <slot name="title">
                            <h6
                                :title="item.translation.name"
                                class="side-bar-text font-weight-bold mb-0"
                                :style="isActive && { color: color.secondary }"
                            >
                                {{ $trim(item.translation.name, 35) }}
                            </h6>
                        </slot>
                    </div>
                    <!-- <i v-if="item.type === 'Exercise'" class="mdi mdi-notebook mdi-18px"/> -->
                </div>
                <div class="text-muted side-bar-text">
                    <span v-if="item.time_video">
                        {{$t('common.duration')}}: {{ item.time_video }}
                    </span>
                    <span v-if="isLive"><i class="mdi mdi-circle pl-2"></i>{{$t('content.type.live')}}</span>
                    <span v-if="item.type_upload">
                        <i class="mdi mdi-file pr-1"/>{{$t('content.type.file')}}
                    </span>
                </div>
            </div>
            <class-content-progress-bar v-if="isActive" :progress="this.content.progress"/>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ClassContentProgressBar from './ClassContentProgressBar';
import Collapse from '../../argon/components/Collapse/Collapse';
import CollapseItem from '../../argon/components/Collapse/CollapseItem';

export default {
    name: 'ClassMenuContent',

    components: {
        ClassContentProgressBar,
        Collapse,
        CollapseItem,
    },

    props: {
        item: {
            type: Object,
            required: true,
        },
        parentType: String,
        childLevel: Number,
        hasParent: Boolean,
        parentId: Number,
        lastContent: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            itemIndex: 0,
        };
    },

    computed: {
        ...mapGetters({
            contentItem: 'CLASS_CONTENT_ITEM',
            actualLesson: 'CLASS_LESSON',
            actualLink: 'CLASS_LINK',
            content: 'CLASS_CONTENT',
            contentIndex: 'CLASS_CONTENT_INDEX',
            menuIndex: 'CLASS_MENU_INDEX',
            language: 'LANGUAGE',
            color: 'COLOR',
        }),
        isLive() {
            return ['LV', 'LVW'].includes(this.item.type_video);
        },
        isActive() {
            return this.itemIndex === this.contentIndex;
        },
        showFinal() {
            if (!this.item.final) return false;
            return this.actualLesson.progress === 100 && this.actualLesson.id === this.parentId;
        },
        hasIconButtons() {
            return this.item.translation.description || this.item.hasForum || this.item.hasCertificate;
        },
        changeIcon() {
            if (this.content.lock_type === 'SCHEDULE') {
                const currentDate = new Date().toISOString().split('T')[0];

                if (this.content.exercise_publish.start_date > currentDate) {
                    return 'mdi mdi-calendar-clock';
                } else if (this.content.exercise_publish.end_date < currentDate) {
                    return 'mdi mdi-calendar-check';
                }
            } else {
                return 'mdi mdi-lock-outline';
            }
        },
    },

    methods: {
        changeClassType() {
            if (this.item.type === 'Lesson') return 'lesson-style';
            if (this.item.type === 'Module') return 'module-style';
            return 'exercise';
        },
        ...mapActions({
            loadContent: 'CLASS_LOAD_CONTENT',
            loadForum: 'CLASS_LOAD_FORUM',
            loadCertificate: 'CLASS_LOAD_CERTIFICATE',
        }),
        ...mapMutations({
            setLink: 'SET_CLASS_CONTENT_LINK',
            setModal: 'SET_CLASS_MODAL',
            setContentItem: 'SET_CLASS_CONTENT_ITEM',
            incrementMenuIndex: 'INCREMENT_MENU_INDEX',
        }),

        async goToCertificate() {
            const currentProgress = await this.actualLesson.progress;
            const certificateProgress = this.item.certificateProgress;
            const generateCertificate = currentProgress >= certificateProgress;
            if (!generateCertificate) {
                return this.$notify({
                    type: 'warning',
                    message: this.$t('class.certificate_without_progress'),
                });
            }
            window.location = `/app/certificate/show/lesson/${this.item.id}`;
        },

        async openModal(tab) {
            await this.setModal({
                tab,
                open: true,
                id: this.item.id,
                type: this.item.type,
                description: this.item.translation.description,
                name: this.item.translation.name,
            });
            if (tab === 'forum') {
                this.loadForum();
            }
        },

        async setContent() {
            var path = this.item.paths.current;
            var indexStart = path.indexOf('?plan=') + 6;
            var indexEnd = path.indexOf('&');
            const planId = parseInt(path.substring(indexStart, indexEnd));
            indexStart = path.indexOf('&course=') + 8;

            var courseId = parseInt(path.substring(indexStart));
            if (path.indexOf('&lesson=') >= 0) {
                indexEnd = path.indexOf('&lesson=');
                courseId = parseInt(path.substring(indexStart, indexEnd));
            }

            const noHavePath = this.item.paths && !this.item.paths.current;
            const isSameContent = this.content.id === this.item.content_id;
            const isParent = this.item.content;

            if (noHavePath || isSameContent || isParent) return null;

            if (this.item.lock) {
                return this.$notify({
                    type: 'warning',
                    message: this.item.lock_message,
                });
            }

            await this.loadContent({ planId: planId, courseId: courseId });

            this.setLink(this.item.paths.current);
            await this.loadContent({ iso: this.language.iso });
        },

        defineCollapseItemStyle() {
            const level = this.childLevel + 1;
            const maximumValue = 18;
            const minimumValue = 15;
            const idealValue = maximumValue/level;
            const fontSize = idealValue > minimumValue ? idealValue : minimumValue;

            return {
                fontSize: `${fontSize}px`,
            };
        },
    },
    async mounted() {
        if (!this.item.content) { this.itemIndex = this.menuIndex; this.incrementMenuIndex(); }
        if (this.isActive && !this.item.content) this.setContentItem({ ...this.contentItem, ...this.item });
    },
    updated() {
        if (this.isActive && !this.item.content) this.setContentItem({ ...this.contentItem, ...this.item });
    },
};
</script>

<style scoped lang="sass">
.parent
    background-color: #fff
    border-bottom: 2px solid #5E72E4
    &.borderSon
        border-bottom: none
.side-bar-text
    font-size: 0.8rem

.son
    position: relative
    cursor: pointer
    &.borderSon
        border-bottom: none
    .activeIndicator
        position: absolute
        top: 0
        right: 100%
        width: 100px
        height: calc(100% - 4px)
        transition: all .25s

.class-item
    position: relative
    width: calc(100% + 2px)
    border: none
    min-height: 60px
    cursor: pointer
    display: flex
    align-items: center
    padding: 10px 0
    transition: all .25s
    height: 70px
    background-color: #fff

.mdi-notebook
    margin-right: .825rem !important
.accordion
    .card.mb-0
        overflow: visible
    .card-header
        a
            color: black !important
            text-decoration: none
        &:after
            font: normal normal normal 12px/1 NucleoIcons

.icons-container
    display: flex
    gap: 10px
    i
        font-size: 20px
        color: black
        cursor: pointer

.title-container
    display: flex
    align-items: center
    justify-content: space-between
    margin-right: 50px

@media screen and (max-width: 1027px)
    .span-title
        max-width: 20vw
        font-size: 12px

.folder-plus
    width: 30px

@media screen and (max-width: 1027px)
    .folder-plus
        font-size: 20px

.br-0
    border-radius: 0

.lesson-style
    height: 60px

.module-style
    height: 65px

.class-menu-content
    margin-left: 27px

.v-tooltip__content
    background: #616161
    border-radius: 2px
    color: #fff
    font-size: 12px
    display: inline-block
    padding: 5px 8px
    position: absolute !important
    text-transform: none
    width: auto
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)

.v-tooltip__content[class*=-active]
    transition: .15s cubic-bezier(.25,.8,.5,1)
    pointer-events: none

.v-tooltip__content--fixed
    position: fixed

.custom-tooltip
    width: 80%
    top: 60px !important
    opacity: 1 !important

.custom-tooltip-exercise
    width: 80%
    top: 40px !important
    opacity: 1 !important
</style>
